


export function InstrucoesProjeto() {


    return (
        <div className="text-lg">
            <div ><span className="font-bold">1.</span> Consulte a escala de trabalho (gráfico gant)</div>
            <hr className="mb-5" />
            <div><span className="font-bold">2.</span> Consulte dados da obra em APPRodrimaq&gt;Obras&gt;Data de entrega xxx&gt;Projeto</div>
            <hr className="mb-5" />
            <div className="mb-2"><span className="font-bold">3.</span> Processar obra:</div>
            <div className="ml-10">
                <div className="mb-2"><span className="font-bold">a.</span> Importar ficheiros desde a pasta da obra no servidor/APP para o Topsolid;
                    atualizado;</div>
                <div className="mb-2"><span className="font-bold">b.</span> Validar peças e adicionar cores de tolerância;</div>
                <div className="mb-2"><span className="font-bold">c.</span> Modelar peças onde o 3D é inexistente;</div>
                <div><span className="font-bold">d.</span> Trocar trabalho com colegas de setor para validação;</div>
            </div>
            <hr className="mb-5" />
        </div>
    )

}